module.exports = __webpack_public_path__ + "media/sunbites.d9cf5507.mp4";